/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconIntercom.vue?vue&type=template&id=e1bbda58&scoped=true"
import script from "./IconIntercom.vue?vue&type=script&lang=js"
export * from "./IconIntercom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bbda58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1bbda58')) {
      api.createRecord('e1bbda58', component.options)
    } else {
      api.reload('e1bbda58', component.options)
    }
    module.hot.accept("./IconIntercom.vue?vue&type=template&id=e1bbda58&scoped=true", function () {
      api.rerender('e1bbda58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconIntercom.vue"
export default component.exports